export default __webpack_public_path__ + "assets/systems-4da0f42.svg";